import { useAuthenticator } from '@aws-amplify/ui-react';

export const useUserAlias = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  return { alias: user?.username?.replace('AmazonFederate_', ''), user };
};
